import type { Theme, SxProps } from "@mui/material/styles";

/**
 * Styles for NumericCellRenderer component
 * Converted from makeStyles to sx-based styling
 */
export const numericCellRendererStyles = (
  theme: Theme,
): Record<string, SxProps<Theme>> => ({
  incrementIcon: {
    "&:hover": {
      color: "green",
    },
  },
  decrementIcon: {
    "&:hover": {
      color: "red",
    },
  },
  numericCellContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "80px",
  },
  valueTypography: {
    minWidth: "20px",
    textAlign: "center",
  },
  iconButton: {
    padding: 0,
  },
  leftIconButton: {
    marginRight: theme.spacing(1),
  },
  rightIconButton: {
    marginLeft: theme.spacing(1),
  },
});
